import { useEffect, useRef, useState } from 'react'

/**
 * Which way a number last moved, for the brief tick flash traders read prices
 * by. Returns 'up' or 'down' for a moment after a change, then null — so the
 * class can be applied unconditionally and the animation restarts each time.
 */
export function useDirection(value: number, holdMs = 620): 'up' | 'down' | null {
  const previous = useRef(value)
  const [direction, setDirection] = useState<'up' | 'down' | null>(null)

  useEffect(() => {
    if (!Number.isFinite(value) || value === previous.current) return
    // The first real value arriving after an empty market is not a move.
    const moved = previous.current > 0 ? (value > previous.current ? 'up' : 'down') : null
    previous.current = value
    if (!moved) return
    setDirection(moved)
    const timer = setTimeout(() => setDirection(null), holdMs)
    return () => clearTimeout(timer)
  }, [value, holdMs])

  return direction
}
